import axios from "axios";

export const onSubmitForm = async (values, token) => {
  try {
    const res = await axios({
      method: "POST",
      url: "https://api.traista.com/api/v1/tsaclaim/",
      headers: {
        // Authorization: "Bearer " + token,
        // "Content-Type": "text/html; charset=UTF-8",
      },
      data: values,
    });
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const onGetAirports = async (value, token) => {
  try {
    const res = await axios({
      method: "GET",
      url: `https://api.traista.com/api/v1/airports/?q=${value}`,
      headers: {
        // Authorization: "Bearer " + token,
        // "Content-Type": "text/html; charset=UTF-8",
      },
    });
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const onVerifyRecaptcha = async (recaptchaToken) => {
  try {
    const res = await axios({
      method: "POST",
      url: "https://api.traista.com/api/v1/tsaclaim/recaptcha",
      headers: {
        // Authorization: "Bearer " + token,
        // "Content-Type": "text/html; charset=UTF-8",
      },
      data: {
        token: recaptchaToken,
      },
    });
    return res.data;
  } catch (error) {
    throw error;
  }
};

export default onSubmitForm;



// WEBPACK FOOTER //
// ./src/api/BaseAPI.js